import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";

const NavbarTabs = ({ onSelect }) => {
    const auth = useAuth();

    const location = useLocation();
    const currentPath = location.pathname;
    const tabNames = useMemo(() => {
            if (auth.isAuthenticated) {
                return ['calculator', 'rates', 'logout'];
            } else {
                return ['calculator', 'rates', 'login'];
            }
    }, [auth]);

    return (
        tabNames.map((value,index) => (
            <li key={index}>
                <button className="btn-flat white-text" 
                    style={{ borderBottom: (currentPath.length === 1 && value === 'calculator') || (currentPath.length > 1 && currentPath.slice(1) === value) ? '3px solid white' : 'none'}} 
                    onClick={() => onSelect(value)}>
                        {value}
                </button>
            </li>))
    )
}

export default NavbarTabs;